import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useLazyUserSupportListQuery,
  useLazyUserResolveListQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import ActivePage from "./ActivePage";
import InActivePage from "./InActivePage";

const UserSupport = () => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const [tab, setTab] = useState(1);
  const [resolvePage, setresolvePage] = useState(1);
  const [supportPage, setSupportPage] = useState(1);
  const [searchSupport, setSearchSupport] = useState("");
  const [searchResolve, setSearchResolve] = useState("");
  const [rowSupport, setRowSupport] = useState(10);
  const [rowResolve, setRowResolve] = useState(10);
  const [listSupport, setListSupport] = useState([]);
  const [listResovle, setListResovle] = useState([]);
  const [supportCount, setSupportCount] = useState(1);
  const [resolveCount, setResolveCount] = useState(1);
  const [paginationSupport, setPagonationSupport] = useState({});
  const [paginationResolve, setPagonationResolve] = useState({});

  // RTK QUERY
  const [userSupportListApi] = useLazyUserSupportListQuery();
  const [userReslvoeListApi] = useLazyUserResolveListQuery();

  const getSupportList = (search_, row_value) => {
    let params = `?page=${supportPage}`;
    dispatch(saveLoader(true));

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setRowSupport(row_value);
    setSearchSupport(search_);
    userSupportListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setListSupport(res?.supports);
        setSupportCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationSupport(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const getResolveList = (search_, row_value) => {
    let params = `?page=${resolvePage}`;

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setRowResolve(row_value);
    setSearchResolve(search_);
    dispatch(saveLoader(true));
    userReslvoeListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setListResovle(res?.supports);
        setResolveCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationResolve(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSupportList(searchSupport, rowSupport);
  }, [supportPage]);

  useEffect(() => {
    getResolveList(searchResolve, rowResolve);
  }, [resolvePage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"user-support-list"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="nav-user mb-4" style={{ overflow: "auto" }}>
            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 1 ? "pre-active" : ""
                }`}
                onClick={() => setTab(1)}
              >
                Active
              </button>
            </div>

            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 2 ? "pre-active" : ""
                }`}
                onClick={() => setTab(2)}
              >
                Inactive
              </button>
            </div>
          </div>
          <div>
            {tab == 1 && (
              <ActivePage
                getSupportList={getSupportList}
                searchSupport={searchSupport}
                setSupportPage={setSupportPage}
                getResolveList={getResolveList}
                supportCount={supportCount}
                listSupport={listSupport}
                paginationSupport={paginationSupport}
                rowSupport={rowSupport}
                type={"user"}
              />
            )}

            {tab == 2 && (
              <InActivePage
                getResolveList={getResolveList}
                searchResolve={searchResolve}
                setresolvePage={setresolvePage}
                resolveCount={resolveCount}
                listResovle={listResovle}
                paginationResolve={paginationResolve}
                rowResolve={rowResolve}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSupport;
